import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'app-practice-account-details',
  templateUrl: './practice-account-details.component.html',
  styleUrls: ['./practice-account-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PracticeAccountDetailsComponent implements OnInit {
  @Input() errorWarningData: any;
  @Input() SettingForm: FormGroup;
  @Input() getDropDownValue;
  sub: Subscription;
  public isspiner: boolean = false;
  private _unsubscribeAll$: Subject<void> = new Subject();
  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    private behaviorService: BehaviorService,
    private toastr: ToastrService,
  ) {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit(): void {}

  /**
   * This function is used to Save the Practice account data value.
   */
  savePracticeAccount(): void {
    this.isspiner = true;
    let data = {
      GroupName: 'BusinessSetup',
      SubgroupName: 'PracticeAccount',
      PRACACCACCOUNTNAME: this.SettingForm.controls.PRACACCACCOUNTNAME.value,
      PRACACCBSB: this.SettingForm.controls.PRACACCBSB.value,
      PRACACCACCOUNTNUMBER: this.SettingForm.controls.PRACACCACCOUNTNUMBER.value,
      SWIFTID: this.SettingForm.controls.SWIFTID.value,
    };

    let data1 = { Action: 'Update', Data: data };
    (this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((response) => {
        if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
          this.isspiner = false;
          this.toastr.success('Updated successfully');
        } else if ((response.CODE == 451 || response.CODE == 450) && response.STATUS == 'warning') {
          this.isspiner = false;
          this.toastr.warning(response.MESSAGE);
        } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
          this.isspiner = false;
          this.toastr.warning(response.MESSAGE);
        } else {
          this.isspiner = false;
        }
      }),
      (error) => {
        this.isspiner = false;
        this.toastr.error(error);
      });
  }
}
